import { observable, action } from 'mobx'
const interval = 500

class Message {
  @observable store = {
    message: [{ success: '', timeStamp: +new Date(), callback: null, time: 2e3 }]
  }
  @action setMessage ({ error, success, callback = null, time = 2e3 }) {
    // 过滤500ms内并发请求的报错
    const timeStamp = +new Date()
    if (this.store.message.length > 1 && timeStamp - this.store.message[this.store.message.length - 1].timeStamp < interval) return
    if (error) this.store.message.push({ error, timeStamp, callback, time })
    if (success) this.store.message.push({ success, timeStamp, callback, time })
  }
}

export default new Message()



// WEBPACK FOOTER //
// ./src/store/modules/message.js